import { createStore } from 'vuex';
import { isLoggedIn, logIn, logOut } from "../utils/auth";
import api from "../api";
import router from "../router";

export default createStore({
  state: {
    user: null,
    selectedTab: null,
    storeSelectedTab: null,
    snack: null,
    // Dynamic breadcrumb labels keyed by route name.
    // Components with entity data commit setBreadcrumbLabel to override the
    // static fallback label defined in the route's meta.breadcrumb.label.
    dynamicBreadcrumbLabels: {},
  },
  getters: {
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },

    setSelectedTab(state, payload) {
      state.selectedTab = payload;
    },

    setStoreSelectedTab(state, payload) {
      state.storeSelectedTab = payload;
    },

    setSnack(state, payload) {
      state.snack = payload;
      setTimeout(() => (state.snack = null), 3000);
    },

    // New breadcrumb system mutations.
    // setBreadcrumbLabel: called by detail/edit page components after they load
    // entity data, so the breadcrumb shows the entity name instead of the
    // static fallback (e.g. "Juan Perez" instead of "Cliente").
    setBreadcrumbLabel(state, { routeName, label }) {
      state.dynamicBreadcrumbLabels = {
        ...state.dynamicBreadcrumbLabels,
        [routeName]: label,
      };
    },

    // clearBreadcrumbLabels: called by the router beforeEach guard on every
    // navigation to prevent stale entity names from the previous page bleeding
    // into the new route's breadcrumb trail.
    clearBreadcrumbLabels(state) {
      state.dynamicBreadcrumbLabels = {};
    },
  },
  actions: {
    login({ commit }, payload) {
      logIn(payload.token);
      commit("setUser", payload.user);
    },

    async loadUser({ commit, dispatch }) {
      if (isLoggedIn()) {
        try {
          const user = await api.auth.me();
          commit("setUser", user);
        } catch (error) {
          if (error.response && error.response.status !== 401) {
            dispatch("logout");
          }
        }
      }
      return Promise.resolve();
    },

    logout({ commit, dispatch }) {
      commit("setUser", null);
      logOut();
      router.push({ name: 'login' });
    },

    errorSnack({ commit }, payload) {
      commit("setSnack", {
        message: payload,
        type: "error",
      });
    },

    successSnack({ commit }, payload) {
      commit("setSnack", {
        message: payload,
        type: "success",
      });
    },
  },
  modules: {
  }
})
